import { TrackingLabel } from "../TrackingLabel";
import { timeSuggest } from "../../times/TimeFactory";
import { SUBMIT_TYPE, submitStore } from "../../store/SubmitStore";

export class SuggestTime extends TrackingLabel<number> {
  readonly name: string = "wk.san_SuggestTime";

  get value(): number {
    return timeSuggest.timeTotal;
  }

  isTrackable(): boolean {
    return submitStore.isSubmitTypeIn([SUBMIT_TYPE.SUGGEST_ITEM]);
  }
}

export const tlSuggestTime = new SuggestTime();
